import { ArrowForward } from "@mui/icons-material";
import { Button } from "@mui/material";
import { Link as RouterLink } from "react-router";

interface ClickThroughLinkProps {
    href: string;
    title: string;
}

export function ClickThroughLink({ href, title }: ClickThroughLinkProps) {
    return (
        <Button
            component={RouterLink}
            to={href}
            size="small"
            sx={{ alignSelf: "flex-end", alignItems: "center", marginTop: "auto" }}
        >
            {title}
            <ArrowForward sx={{ height: "0.75rem", width: "0.75rem" }} />
        </Button>
    );
}
